import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

//import { Button, FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import { InputLabel, Select as MSelect, Radio, MenuItem, TextField, Checkbox, FormControlLabel, Divider, Button, Paper, Typography, FormControl, FormHelperText } from 'material-ui';
import { Icon, IconButton } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';

import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';

import moment from 'moment';
import 'react-select/dist/react-select.css'
import Select from 'react-select';
import 'react-day-picker/lib/style.css';
import { confirmAlert } from 'react-confirm-alert';



const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0
    }
});


class MainAccount extends Component {

    constructor(props) {
        super(props);

        this.state = {
            accountTypes: [],
            accountType: '',
            accountCategoryRefNos: [],
            accountCategoryRefNo: '',
            accountCategoryNames: [],
            accountCategoryName: '',
            accountCategories: [],
            mainAccountName: '',
            description: '',
            records: [],
            editValues: {
                ID_ACCOUNT_CATEGORY: '',
                ID_ACCOUNT_TYPE: ''
            },
            isActive: true,
            open: false,
            loading: false
        };


        this.populateFileds();

        this.handleEditTextBoxChange = this.handleEditTextBoxChange.bind(this);


    }

    getAccountCategoriesByType() {
        var accountCategoryNames = [];
        var accountCategoryRefNos = [];

        console.log('this.state.accountType', this.state.accountType);
        console.log('this.state.accountCategories', this.state.accountCategories);
        for (let i = 0; i < this.state.accountCategories.length; i++) {
            if (/* this.state.accountType=='' ||  */String(this.state.accountCategories[i].accountTypeId) == String(this.state.accountType)) {
                accountCategoryNames.push({ value: this.state.accountCategories[i].id, label: this.state.accountCategories[i].name });
                accountCategoryRefNos.push({ value: this.state.accountCategories[i].id, label: this.state.accountCategories[i].referenceNo });
            }
        }
        console.log('accountCategoryNames', accountCategoryNames);
        console.log('accountCategoryRefNos', accountCategoryRefNos);
        return { accountCategoryNames, accountCategoryRefNos };
    }

    handleAccountTypeChange = (selectedOption) => {
        if (selectedOption) {
            this.setState({ accountType: selectedOption.value, /* customerType2:selectedOption.value */ })
        }
        else {
            this.setState({ accountType: '' });
        }
    }

    handleAccountCatRefChange = (selectedOption) => {
        if (selectedOption) {
            this.setState({ accountCategoryRefNo: selectedOption.value, accountCategoryName: selectedOption.value });
        }
        else {
            this.setState({ accountCategoryRefNo: '', accountCategoryName: '' });
        }
    }

    getEditAccountCategoriesByType() {
        var accountCategoryNames = [];
        var accountCategoryRefNos = [];

        console.log('this.state.editValues.ID_ACCOUNT_CATEGORY', this.state.editValues.ID_ACCOUNT_CATEGORY);
        console.log('this.state.accountCategories', this.state.accountCategories);
        for (let i = 0; i < this.state.accountCategories.length; i++) {
            if (this.state.editValues.ID_ACCOUNT_TYPE == '' || String(this.state.accountCategories[i].accountTypeId) == String(this.state.editValues.ID_ACCOUNT_TYPE)) {
                accountCategoryNames.push({ value: this.state.accountCategories[i].id, label: this.state.accountCategories[i].name });
                accountCategoryRefNos.push({ value: this.state.accountCategories[i].id, label: this.state.accountCategories[i].referenceNo });
            }
        }
        console.log('editAccountCategoryNames', accountCategoryNames);
        console.log('editAccountCategoryRefNos', accountCategoryRefNos);
        return { accountCategoryNames, accountCategoryRefNos };
    }

    handleEditAccountTypeChange = (selectedOption) => {
        if (selectedOption) {
            this.setState(prevState => ({
                editValues: {
                    ...prevState.editValues,
                    ID_ACCOUNT_TYPE: selectedOption.value
                }
            }))
        }
        else {
            this.setState(prevState => ({
                editValues: {
                    ...prevState.editValues,
                    ID_ACCOUNT_TYPE: ''
                }
            }))
        }
    }

    handleEditAccountCatRefChange = (selectedOption) => {
        if (selectedOption) {
            this.setState(prevState => ({
                editValues: {
                    ...prevState.editValues,
                    ID_ACCOUNT_CATEGORY: selectedOption.value
                }
            }))
        }
        else {
            this.setState(prevState => ({
                editValues: {
                    ...prevState.editValues,
                    ID_ACCOUNT_CATEGORY: ''
                }
            }))
        }
    }

    handleCheckBoxChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleEditTextBoxChange = name => event => {
        console.log(event.target.value);
        let value = event.target.value;
        this.setState(prevState => ({
            editValues: {
                ...prevState.editValues,
                [name]: value
            }
        }));
    }


    populateFileds() {
        this.getMainAccountJoin();
        this.getAccountTypes();
        this.getAccountCategories();
    }

    getAccountTypes() {
        console.log('getting account types...');

        this.setState({ loading: true });
        const request = axios.get(window.accountServer + '/accountType/getAccountTypes');
        request.then((response) => {

            if (!response.data.error && response.data.success) {
                console.log('account types recieved', response.data);
                let accountTypes = [];

                for (let i = 0; i < response.data.accountTypes.length; i++) {
                    accountTypes.push({ value: response.data.accountTypes[i].ID_ACCOUNT_TYPE, label: response.data.accountTypes[i].NAME });
                }

                this.setState({
                    accountTypes: accountTypes
                });

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    getAccountCategories() {
        console.log('getting account categories...');

        this.setState({ loading: true });
        const request = axios.get(window.accountServer + '/accountCategory/getAccountCategoryMeta');
        request.then((response) => {

            if (!response.data.error && response.data.success) {
                console.log('account categories recieved', response.data);
                let accountCategoryNames = [];
                let accountCategoryRefNos = [];
                let accountCategories = [];

                for (let i = 0; i < response.data.accountCategories.length; i++) {
                    accountCategoryNames.push({ value: response.data.accountCategories[i].ID_ACCOUNT_CATEGORY, label: response.data.accountCategories[i].NAME });
                    accountCategoryRefNos.push({ value: response.data.accountCategories[i].ID_ACCOUNT_CATEGORY, label: response.data.accountCategories[i].REFERENCE_NO });
                    accountCategories.push(
                        {
                            id: response.data.accountCategories[i].ID_ACCOUNT_CATEGORY,
                            name: response.data.accountCategories[i].NAME,
                            accountTypeId: response.data.accountCategories[i].ID_ACCOUNT_TYPE,
                            referenceNo: response.data.accountCategories[i].REFERENCE_NO,
                        }
                    );
                }

                this.setState({
                    accountCategoryNames: accountCategoryNames,
                    accountCategoryRefNos: accountCategoryRefNos,
                    accountCategories: accountCategories
                });

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }


    getMainAccountJoin() {
        console.log('getting account types...');

        this.setState({ loading: true });
        const request = axios.get(window.accountServer + '/mainAccount/getMainAccountJoin');
        //const request = axios.get("http://192.169.143.105:5009/mainAccount/getMainAccountJoin");
        request.then((response) => {

            if (!response.data.error && response.data.success) {
                console.log('main account data recieved', response.data);
                let records = [];

                if (!response.data.mainAccounts) {
                    this.setState({ records: [] });
                }
                else {

                }
                /* response.data.mainAccounts.map(item=>{
                    records.push(
                        {
                            // to do
                        }
                    );
                } ); */


                this.setState({
                    records: response.data.mainAccounts
                });

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    handleSaveClick() {
        if (this.state.mainAccountName == '' || this.state.mainAccountName == null) {
            this.props.alert.error('Please fill main account name');
            return;
        }

        if (this.state.accountType == '' || this.state.accountCategoryRefNo == '') {
            this.props.alert.error('Please select account type and category');
            return;
        }

        var REF_ACC_CATEGORY = '';
        for (let i = 0; i < this.state.accountCategories.length; i++) {
            if (String(this.state.accountCategories[i].id) === String(this.state.accountCategoryRefNo)) {
                REF_ACC_CATEGORY = this.state.accountCategories[i].referenceNo;
            }
        }

        var insert = {
            NAME: this.state.mainAccountName,
            DESCRIPTION: this.state.description,
            ID_ACCOUNT_TYPE: this.state.accountType,
            ID_ACCOUNT_CATEGORY: this.state.accountCategoryRefNo,
            REF_ACC_CATEGORY: REF_ACC_CATEGORY,
            IS_ACTIVE: 1
        };

        this.setState({ loading: true });
        const request = axios.post(window.accountServer + '/mainAccount/addMainAccount', insert);
        request.then((response) => {
            console.log('addMainAccount response', response.data);

            if (!response.data.error && response.data.success) {
                console.log('addMainAccount successful', response.data);
                this.props.alert.success('Main Account Added');
                let records = [];

                this.setState({ loading: false },
                    () => {
                        this.populateFileds();
                        this.handleClearClick();
                    });
            }
            else {
                console.log('account type add error', response.data);
                this.props.alert.error('account type not added');
                this.setState({ loading: false });
            }
        });
    }

    handleChangeClick() {
        if (this.state.editValues.ID_ACCOUNT_TYPE == '' || this.state.editValues.ID_ACCOUNT_CATEGORY == '') {
            this.props.alert.error('Please select account type and category');
            return;
        }

        var REF_ACC_CATEGORY = '';
        for (let i = 0; i < this.state.accountCategories.length; i++) {
            if (String(this.state.accountCategories[i].id) === String(this.state.editValues.ID_ACCOUNT_CATEGORY)) {
                REF_ACC_CATEGORY = this.state.accountCategories[i].referenceNo;
            }
        }

        var insert = {
            ID_MAIN_ACCOUNT: this.state.editValues.ID_MAIN_ACCOUNT,
            ID_ACCOUNT_TYPE: this.state.editValues.ID_ACCOUNT_TYPE,
            ID_ACCOUNT_CATEGORY: this.state.editValues.ID_ACCOUNT_CATEGORY,
            REF_ACC_CATEGORY: REF_ACC_CATEGORY,
            NAME: this.state.editValues.NAME,
            DESCRIPTION: this.state.editValues.DESCRIPTION,
            REFERENCE_NO: this.state.editValues.REFERENCE_NO,
        };

        this.setState({ loading: true });
        const request = axios.post(window.accountServer + '/mainAccount/updateMainAccount', insert);
        request.then((response) => {
            console.log('addMainAccount response', response.data);

            if (!response.data.error && response.data.success) {
                console.log('updateMainAccount successful', response.data);
                this.props.alert.success('Main Account Updated');
                let records = [];

                this.setState({ loading: false },
                    () => {
                        this.populateFileds();
                        this.handleClose();
                    });
            }
            else {
                console.log('Main Account Update Error', response.data);
                this.setState({ loading: false });
                this.handleClose();
                this.props.alert.error('Main Account Update Failed');
            }
        });
    }

    deleteMainAccount(ID_MAIN_ACCOUNT, IS_ACTIVE) {
        this.setState({ loading: true });
        var request;
        var body = { ID_MAIN_ACCOUNT: ID_MAIN_ACCOUNT };
        var alert = !IS_ACTIVE ? "activation successful" : "deactivation successful";
        if (IS_ACTIVE) {
            request = axios.post(window.accountServer + '/mainAccount/deactivateMainAccount', body);
        } else {
            request = axios.post(window.accountServer + '/mainAccount/activateMainAccount', body);
        }
        request.then((response) => {
            console.log('activateMainAccount/deactivateMainAccount response', response.data);

            if (!response.data.error && response.data.success) {
                console.log('activateMainAccount/deactivateMainAccount successful', response.data);
                this.props.alert.success(alert);

                this.setState({ loading: false },
                    () => {
                        this.populateFileds();
                    });
            }
            else {
                console.log('Main Account Activation Error', response.data);
                this.props.alert.error('Main Account Update Failed');
                this.setState({ loading: false });
            }
        });
    }

    handleClearClick() {
        this.setState(
            {
                accountCategoryRefNo: '',
                accountCategoryName: '',
                accountType: '',
                mainAccountName: '',
                description: ''
            }
        );
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    componentWillMount() { }

    render() {
        const { classes } = this.props;

        var borderStyle = {
            'border-bottom': '4px solid darkgrey',
            'background-color': 'lightgrey',
            'border-style': 'inset'
        };

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="pl-8 ">
                    <div className="p-8">
                        <h2 className="subtitle-color">Main Account</h2>
                    </div>
                    <fieldset style={borderStyle} className="mt-8 mr-16  p-8 pb-16 account-form-color ">
                        <div className="block">
                            <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                Account Type *
                                <Select
                                    className=""
                                    name="form-field-name"
                                    placeholder="Account Type"
                                    value={this.state.accountType}
                                    onChange={this.handleAccountTypeChange}
                                    options={this.state.accountTypes}
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                Account Category Ref No *
                                <Select
                                    className=""
                                    name="form-field-name"
                                    placeholder="Account Category Ref No"
                                    value={this.state.accountCategoryRefNo}
                                    onChange={this.handleAccountCatRefChange}
                                    options={this.getAccountCategoriesByType().accountCategoryRefNos}
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                Account Category Name *
                                <Select
                                    className=""
                                    name="form-field-name"
                                    placeholder="Account Category Name"
                                    value={this.state.accountCategoryName}
                                    onChange={this.handleAccountCatRefChange}
                                    options={this.getAccountCategoriesByType().accountCategoryNames}
                                />
                            </div>

                            <div className="block p-10 main-account-form-margin">

                                <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                    <div className="block" >Main Account Name*</div>
                                    <TextField
                                        className="block"
                                        id="mainAccountName"
                                        value={this.state.mainAccountName}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        onChange={this.handleTextBoxChange('mainAccountName')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="w-full sm:w-1/2 md:w-1/5 px-8 inline-block  ">
                                    <div className="block" >Description</div>
                                    <TextField
                                        className="block"
                                        id="description"
                                        value={this.state.description}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        onChange={this.handleTextBoxChange('description')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                            </div>

                        </div>





                        <div className="block w-full mb-16">
                            <div className="float-right">
                                <Button
                                    variant="raised" color="secondary" className="mx-16 mt-16 pb-15 " aria-label="Save"
                                    //disabled={!canSubmit}
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.handleSaveClick();
                                    }}
                                >
                                    Save
                            </Button>

                                <Button variant="raised" color="primary" className="mx-16 mt-16 pb-15 " aria-label="Clear"
                                    //disabled={!canSubmit}
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.handleClearClick();
                                    }}
                                >
                                    Clear
                            </Button>

                                <Button variant="raised" color="primary" className="mx-16 mt-16 pb-15" aria-label="Help"
                                //disabled={!canSubmit}
                                >
                                    Help
                            </Button>
                            </div>
                        </div>
                    </fieldset>

                    <div className="main-account-margin">
                        <ReactTable

                            data={this.state.records}
                            filterable
                            columns={[

                                {
                                    Header: "Account Type",
                                    accessor: "ACCOUNT_TYPE"
                                },
                                {
                                    Header: "Account Category Ref No",
                                    accessor: "ACCOUNT_CATEGORY_REF_NO"
                                },
                                {
                                    Header: "Account Category",
                                    accessor: "ACCOUNT_CATEGORY"
                                },
                                {
                                    Header: "Main Account Ref No",
                                    accessor: "REFERENCE_NO"
                                },
                                {
                                    Header: "Main Account Name",
                                    accessor: "NAME"
                                },
                                {
                                    Header: "Description",
                                    accessor: "DESCRIPTION"
                                },
                                /* {
                                    Header: "Status",
                                    accessor: "STATUS"
                                }, */
                                {
                                    Header: "Action",
                                    className: "justify-center",
                                    width: 128,
                                    Cell: row => (
                                        row.original.IS_ACTIVE == true ?


                                            (<div className="flex items-center">
                                                <IconButton
                                                    className={classes.smaller}
                                                    title="Do you want to inactive?"
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.deleteMainAccount(row.original.ID_MAIN_ACCOUNT, row.original.IS_ACTIVE)
                                                    }}

                                                >
                                                    <Icon className='text-green'>check_circle</Icon>
                                                </IconButton>
                                                <IconButton
                                                    className={classes.smaller}
                                                    title="Edit"
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.setState({
                                                            editValues: {
                                                                ID_MAIN_ACCOUNT: row.original.ID_MAIN_ACCOUNT,
                                                                ID_ACCOUNT_TYPE: row.original.ID_ACCOUNT_TYPE,
                                                                ID_ACCOUNT_CATEGORY: row.original.ID_ACCOUNT_CATEGORY,
                                                                NAME: row.original.NAME,
                                                                DESCRIPTION: row.original.DESCRIPTION,
                                                                REFERENCE_NO: row.original.REFERENCE_NO
                                                            }
                                                        },
                                                            () => {
                                                                this.handleClickOpen();
                                                            });

                                                    }}

                                                >
                                                    <Icon className="text-blue">mode_edit</Icon>
                                                </IconButton>

                                                <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title" >
                                                    <DialogTitle id="form-dialog-title">Change Main Account</DialogTitle>
                                                    <DialogContent>
                                                        <div>

                                                            <div className="w-full px-8  inline-block">
                                                                Account Type *
                                                            {this.state.editValues.ID_ACCOUNT_TYPE}
                                                                <Select
                                                                    className=""
                                                                    name="form-field-name"
                                                                    placeholder="Account Type"
                                                                    value={this.state.editValues.ID_ACCOUNT_TYPE}
                                                                    onChange={this.handleEditAccountTypeChange}
                                                                    options={this.state.accountTypes}
                                                                />
                                                            </div>
                                                            <div className="w-full px-8  inline-block">
                                                                Account Category Ref No *
                                                            {this.state.editValues.ID_ACCOUNT_CATEGORY}
                                                                <Select
                                                                    className=""
                                                                    name="form-field-name"
                                                                    placeholder="Account Category Ref No"
                                                                    value={this.state.editValues.ID_ACCOUNT_CATEGORY}
                                                                    onChange={this.handleEditAccountCatRefChange}
                                                                    options={this.getEditAccountCategoriesByType().accountCategoryRefNos}
                                                                />
                                                            </div>
                                                            <div className="w-full px-8  inline-block">
                                                                Account Category Name *
                                                            <Select
                                                                    className=""
                                                                    name="form-field-name"
                                                                    placeholder="Account Category Name"
                                                                    value={this.state.editValues.ID_ACCOUNT_CATEGORY}
                                                                    onChange={this.handleEditAccountCatRefChange}
                                                                    options={this.getEditAccountCategoriesByType().accountCategoryNames}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="block">
                                                            <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                                                <div className="block" >Main Account Name*</div>
                                                                <TextField
                                                                    className="block"
                                                                    id="mainAccountName"
                                                                    value={this.state.editValues.NAME}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    onChange={this.handleEditTextBoxChange('NAME')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="w-full sm:w-1/2 md:w-1/5 px-8  ">
                                                                <div className="block" >Description</div>
                                                                <TextField
                                                                    className="block"
                                                                    id="description"
                                                                    value={this.state.editValues.DESCRIPTION}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    onChange={this.handleEditTextBoxChange('DESCRIPTION')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>


                                                             <DialogActions className="justify-right pl-16">
                                                            <div className="max-w-256 p-20">

                                                             <Button
                                                                    type="submit"
                                                                    variant="raised"
                                                                    color="secondary"
                                                                    className="mx-auto mt-16 main-account-btn"
                                                                    aria-label="Save"
                                                                    //disabled={!canSubmit2}
                                                                    onClick={
                                                                        (ev) => {
                                                                            ev.stopPropagation();
                                                                            this.handleChangeClick();
                                                                        }
                                                                    }
                                                                >
                                                                    Change
                                                            </Button>

                                                                <Button
                                                                    color="primary"
                                                                    variant="raised"
                                                                    className="mx-auto mt-16"
                                                                    onClick={
                                                                        (ev) => {
                                                                            ev.stopPropagation();
                                                                            this.handleClose();
                                                                        }
                                                                    }
                                                                >
                                                                    Close
                                                            </Button>

                                                               
                                                            </div>
                                                            </DialogActions>
                                                        </ div>


                                                    </DialogContent>
                                                    {/* <DialogActions>
                                                        <Button onClick={this.handleClose} color="primary">
                                                            {this.state.editValues.categoryName}
                                                        </Button>
                                                        <Button onClick={this.handleClose} color="primary">
                                                            Subscribe
                                                        </Button>
                                                    </DialogActions> */}
                                                </Dialog>

                                            </div>)

                                            :

                                            (<div className="flex items-center">
                                                <IconButton
                                                    className={classes.smaller}
                                                    title="Do you want to active?"
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.deleteMainAccount(row.original.ID_MAIN_ACCOUNT, row.original.IS_ACTIVE)
                                                    }}

                                                >
                                                    <Icon className='text-red'>cancel</Icon>
                                                </IconButton>

                                            </div>)
                                    )
                                }
                            ]}
                            //pageSize={this.state.records.length>3?this.state.records.length:3}
                            defaultPageSize={10}
                            className="-striped -highlight"
                        />
                    </div>
                </div>
            )


        }
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(MainAccount));


// WEBPACK FOOTER //
// ./src/main/content/accounting/main/MainAccount.js